/**
 * Route <select> helpers for the admin screens.
 *
 * GET /api/admin/routes returns soft-deleted routes too (is_active false),
 * and tenants reuse names — Mr Farmer had three routes called "Route 1",
 * two of them deleted. The customer screens listed all of them unlabelled,
 * so customers were put on a DELETED "Route 1" that has no rider: every day
 * their deliveries were generated rider-less and had to be assigned by hand.
 */
export const isDeletedRoute = (r) => r?.is_active === false;

export const routeOptionLabel = (r) => `${r?.name || "Route"}${isDeletedRoute(r) ? " (deleted)" : ""}`;

/** Options for ASSIGNING a route: active routes only, plus the currently
 *  selected one if it was deleted (shown so the select isn't blank, and
 *  flagged `disabled` so it can't be picked again). */
export function assignableRoutes(routes, currentId) {
  return (routes || [])
    .filter((r) => !isDeletedRoute(r) || r.id === currentId)
    .map((r) => ({ ...r, disabled: isDeletedRoute(r) }));
}

/** Options for FILTERING by route: every route, deleted ones labelled and
 *  listed last — so an admin can find customers stuck on a deleted route. */
export function filterableRoutes(routes) {
  return [...(routes || [])].sort((a, b) => Number(isDeletedRoute(a)) - Number(isDeletedRoute(b)));
}
